import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { registerIdentifiedUser } from 'src/common/utils'
import { ILoginUser } from 'src/services/types/user'

interface UserState {
    data: ILoginUser | null
    passwordReset: any
    changedPassword: {
        success: any
        error: any
        data: any
    }
}

const initialState = {
    data: null,
    passwordReset: null,
    changedPassword: {
        success: null,
        error: null,
        data: null
    }
} as UserState

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        updateUserData(state, action: PayloadAction<ILoginUser>) {
            state.data = action.payload
            registerIdentifiedUser(action.payload)
        },
        updateUserReferralCode(
            state,
            action: PayloadAction<ILoginUser['voucherifyReferralCode']>
        ) {
            state.data.voucherifyReferralCode = action.payload
        },
        clearPasswordReset(state) {
            state.passwordReset = ''
        },
        clearChangedPassword(state) {
            state.changedPassword.data = ''
            state.changedPassword.error = ''
        },
        resetUserData(state) {
            state.data = initialState.data
            state.passwordReset = initialState.passwordReset
            state.changedPassword = initialState.changedPassword
        }
    },
    extraReducers: {
        [HYDRATE]: (state, action: PayloadAction<any>) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return {
                ...state,
                ...action.payload.user
            }
        }
    }
})

const { actions } = userSlice

export const {
    clearPasswordReset,
    clearChangedPassword,
    updateUserData,
    resetUserData,
    updateUserReferralCode
} = actions

export default userSlice
